<div class="p-a-xl">
    <app-data-card-settings [screen]="screen"></app-data-card-settings>
</div>
